export default __webpack_public_path__ + "static/media/jap-ecommerceImg_5.d40d8dcb.webp";